import React, { FC, ReactNode } from 'react';

import { useLocation } from 'react-router';
import styled from 'styled-components';

import { useI18n, useSelector } from 'Hooks';

import { PERMISSION_PATHS } from './consts';

export const Wrapper = styled.div`
  text-align: center;
  color: rgb(28 35 44 / 60%);
  padding: 0 36px;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 100px;
`;

export const Title = styled.p`
  color: var(--colorBlueGray1200);
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 10px;
`;

interface Props {
  children: ReactNode;
}

/* A checker component to see if the user is eligible to see the Component - otherwise default to a Access Denied page */
const PermissionChecker: FC<Props> = ({ children }) => {
  const { t } = useI18n();
  const userPermissions = useSelector((state) => state.userPermissions);
  const location = useLocation();
  const path = location.pathname;

  const requiredScopes = PERMISSION_PATHS[path] || [];

  /* Check if user has permission - or if no permissions is required */
  const hasPermissions =
    requiredScopes.length === 0 || // If no permissions is required
    userPermissions?.scopes.length === 0 || // This gives full permissions
    requiredScopes.some((scope) => userPermissions?.scopes.includes(scope)); // Check if user has the required permissions

  if (hasPermissions) {
    return <>{children}</>;
  }

  return (
    <Wrapper>
      <Title>{t('NoPermissions.Title')}</Title>
      {t('NoPermissions.Subtitle')}
    </Wrapper>
  );
};

export default PermissionChecker;
